var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section " }, [
    _c(
      "div",
      {
        staticClass: "triggers",
        staticStyle: { "padding-bottom": "10px" },
        attrs: { slot: "operations" },
        slot: "operations"
      },
      [
        _vm.action !== "view"
          ? [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: { click: _vm.cancel }
                },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toSave } },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")) + " ")]
              )
            ]
          : [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.back } },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Return")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toEdit } },
                [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")) + " ")]
              )
            ]
      ],
      2
    ),
    _c("div", { staticStyle: { display: "flex" } }, [
      _c(
        "div",
        { staticStyle: { width: "500px" } },
        [
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.action === "view",
                "label-width": "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.BelongingSystem")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.form.systemSource,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "systemSource", $$v)
                                },
                                expression: "form.systemSource"
                              }
                            },
                            _vm._l(_vm.systemSourceList, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.BelongsToModule")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.form.module,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "module", $$v)
                                },
                                expression: "form.module"
                              }
                            },
                            _vm._l(_vm.moduleList, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.BelongsToPage")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.form.page,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "page", $$v)
                                },
                                expression: "form.page"
                              }
                            },
                            _vm._l(_vm.pageList, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SystemMaintenance.AdLocation")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.form.title,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "title", $$v)
                                },
                                expression: "form.title"
                              }
                            },
                            _vm._l(_vm.positionList, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SystemMaintenance.Status") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { disabled: true },
                              model: {
                                value: _vm.form.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status"
                              }
                            },
                            _vm._l(_vm.statusList, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: item.chineseName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SystemMaintenance.MaximumSupportedAdCount"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.pushMaxNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "pushMaxNumber", $$v)
                              },
                              expression: "form.pushMaxNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", [
        _c("img", {
          staticStyle: { height: "580px", margin: "0 auto" },
          attrs: { src: _vm.src }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }